/* import __COLOCATED_TEMPLATE__ from './tab-header.hbs'; */
import Component from '@glimmer/component';

export default class TabHeader extends Component {}
